// src/components/gradedata/gradeData.jsx

const gradeData = {
  Montcare: {
    textBooks: [
      "My Favourite rhymes",
      "Colouring Book",
      "Begin with ABC",
      "Scribbling book (plain, drawing book) – 2 No’s",
      "Scrap book – 1 No"
    ],
    additionalBooks: [],
    noteBooks: [],
    stationery: [
      { item: "Pencils", qty: "" },
      { item: "Erasers, Sharpeners", qty: "" },
      { item: "Crayons", qty: "" },
      { item: "Clay", qty: "" },
      { item: "Folder", qty: "" },
      { item: "Labels", qty: "8" },
      { item: "Roll", qty: "1" },
      { item: "Diary", qty: "1" }
    ],
    uniform: ["School Wear (will be issued/used in school)"],
    fee: [
      { term: "I Term", amount: "22,000", payBy: "Admission" },
      { term: "II Term", amount: "22,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "22,000", payBy: "10th December 2026" }
    ]
  },

  "Prep I": {
    textBooks: [
      "Literacy",
      "Numeracy",
      "Rhymes Book",
      "Story Book",
      "World Around Us",
      "Art and Craft",
      "Flashcards"
    ],
    additionalBooks: ["My Best Friend Orient Black Swan Books Kit", "Health Education"],
    noteBooks: [
      { name: "Four lines", pages: "200 pages", qty: "1" },
      { name: "Four lines", pages: "100 pages", qty: "1" },
      { name: "Square", pages: "200 pages", qty: "1" },
      { name: "Square", pages: "100 pages", qty: "1" },
      { name: "Drawing Book", pages: "40 pages", qty: "1" },
      { name: "Scrap Book", pages: "40 pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "14" },
      { item: "Books Wrapper", qty: "1 Roll" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "25,000", payBy: "Admission" },
      { term: "II Term", amount: "25,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "32,000", payBy: "10th December 2026" }
    ]
  },

  "Prep II": {
    textBooks: [
      "Literacy Book",
      "Numeracy Book",
      "Phonics & Rhymes Book",
      "World Around Us",
      "Story Book",
      "Flash Cards"
    ],
    additionalBooks: [
      "My Best Friend Orient Black Swan Books Kit",
      "Art and Craft Skill Book",
      "Health Education"
    ],
    noteBooks: [
      { name: "Square line", pages: "200 Pages", qty: "1" },
      { name: "Square line", pages: "100 Pages", qty: "3" },
      { name: "Four Line", pages: "200 pages", qty: "1" },
      { name: "Four Line", pages: "100 pages", qty: "4" },
      { name: "Drawing book", pages: "40 pages", qty: "1" },
      { name: "Scrap Book", pages: "40 pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "21" },
      { item: "Books Wrapper", qty: "1 Roll" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "25,000", payBy: "Admission" },
      { term: "II Term", amount: "32,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "32,000", payBy: "10th December 2026" }
    ]
  },

  "Prep III": {
    textBooks: [
      "Literacy Book",
      "Numeracy Book",
      "Phonics & Rhymes Book",
      "World Around Us",
      "Story Book",
      "Flash Cards",
      "Hindi Baal Kavitha",
      "Hindi Varnamala",
      "Hindi Sulekhamala",
      "English Cursive"
    ],
    additionalBooks: [
      "My Best Friend Orient Black Swan Books Kit",
      "Art and Craft Skill Book",
      "Health Education",
      "Magic Pot Book"
    ],
    noteBooks: [
      { name: "Square line", pages: "200 Pages", qty: "2" },
      { name: "Square line", pages: "100 Pages", qty: "2" },
      { name: "Four Line", pages: "200 pages", qty: "4" },
      { name: "Four Line", pages: "100 pages", qty: "3" },
      { name: "Double Ruled", pages: "200 pages", qty: "1" },
      { name: "Double Ruled", pages: "100 pages", qty: "1" },
      { name: "Drawing book", pages: "40 pages", qty: "1" },
      { name: "Scrap Book", pages: "40 pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "28" },
      { item: "Books Wrapper", qty: "1 Roll" },
      { item: "Brownsheet", qty: "5" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "28,000", payBy: "Admission" },
      { term: "II Term", amount: "32,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "32,000", payBy: "10th December 2026" }
    ]
  },

  "1": {
    textBooks: [
      "Eng Literature – Magnolia",
      "Eng Language – Gems English Grammar",
      "Mathematics – Inspired Maths",
      "EVS – Inspired EVS",
      "Computer – Pointerz",
      "Eng – English Cursive writing",
      "Hindi – Millennium Hindi Patmala",
      "Hindi Copy Writing – Sulekhmala Hindi Cursive writing",
      "Namma Kannada Book 0",
      "Kannada copy writing – Amulya Kannada copy writing"
    ],
    additionalBooks: [
      "Magic Pot Book",
      "Art & Craft – My Art My Way",
      "Health Education Book"
    ],
    noteBooks: [
      { name: "Single ruled", pages: "200 Pages", qty: "2" },
      { name: "Single ruled", pages: "100 Pages", qty: "2" },
      { name: "Four lines", pages: "100 Pages", qty: "9" },
      { name: "Square", pages: "100 Pages", qty: "3" },
      { name: "Double ruled", pages: "200 Pages", qty: "1" },
      { name: "Double ruled", pages: "100 Pages", qty: "5" },
      { name: "One Side ruled", pages: "200 Pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "36" },
      { item: "Books Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "33,000", payBy: "Admission" },
      { term: "II Term", amount: "33,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "2": {
    textBooks: [
      "Eng Literature – Magnolia",
      "Eng Language – Gems English Grammar",
      "Mathematics – Inspired Maths",
      "EVS – Inspired EVS",
      "Computer – Pointerz",
      "Eng – English Cursive writing",
      "Hindi – Millennium Hindi Patmala",
      "Hindi Copy Writing – Sulekhmala Hindi Cursive writing",
      "Kannada – Namma Kannada Book 1",
      "Kannada copy writing – Amulya Kannada copy writing"
    ],
    additionalBooks: [
      "Magic Pot Book",
      "Art & Craft – My Art My Way",
      "Health Education Book"
    ],
    noteBooks: [
      { name: "Single Ruled", pages: "200 Pages", qty: "2" },
      { name: "Single Ruled", pages: "100 Pages", qty: "2" },
      { name: "Four lines", pages: "200 Pages", qty: "1" },
      { name: "Four lines", pages: "100 Pages", qty: "8" },
      { name: "Double ruled", pages: "200 Pages", qty: "2" },
      { name: "Double ruled", pages: "100 Pages", qty: "4" },
      { name: "Horizontal Maths", pages: "200 Pages", qty: "1" },
      { name: "Horizontal Maths", pages: "100 Pages", qty: "2" },
      { name: "One side ruled", pages: "200 Pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "36" },
      { item: "Books Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "33,000", payBy: "Admission" },
      { term: "II Term", amount: "36,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "3": {
    textBooks: [
      "Eng Literature – Magnolia",
      "Eng Language – Gems English Grammar",
      "Mathematics – Inspired Maths",
      "Science – Inspired Science",
      "Social Studies – Inspired Social",
      "Computer – Pointerz",
      "English Cursive writing",
      "Hindi – Millennium Hindi Patmala",
      "Hindi Copy Writing – Sulekhmala Hindi Cursive writing",
      "Kannada – Namma Kannada Book 2",
      "Kannada copy writing – Amulya Kannada copy writing"
    ],
    additionalBooks: [
      "National Geographic Book",
      "Art & Craft – My Art My Way",
      "Health Education Book"
    ],
    noteBooks: [
      { name: "Single ruled", pages: "200 Pages", qty: "2" },
      { name: "Single ruled", pages: "100 Pages", qty: "2" },
      { name: "Horizontal Maths", pages: "200 Pages", qty: "1" },
      { name: "Horizontal Maths", pages: "100 Pages", qty: "2" },
      { name: "One side ruled", pages: "200 Pages", qty: "1" },
      { name: "Double line", pages: "200 Pages", qty: "2" },
      { name: "Double line", pages: "100 Pages", qty: "4" },
      { name: "Four line", pages: "200 pages", qty: "1" },
      { name: "Four line", pages: "100 Pages", qty: "8" }
    ],
    stationery: [
      { item: "Labels", qty: "37" },
      { item: "Books Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "33,000", payBy: "Admission" },
      { term: "II Term", amount: "36,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "4": {
    textBooks: [
      "Eng Literature – Magnolia",
      "Eng Language – Gems English Grammar",
      "Mathematics – Inspired Maths",
      "Science – Inspired Science",
      "Social Studies – Inspired Social",
      "Computer – Pointerz",
      "English Cursive writing",
      "II Language Hindi – Madhukiran",
      "III Language Hindi – Elementary Hindi Reader 3",
      "Hindi Copy Writing – Sulekhmala Hindi Copy writing",
      "II Language Kannada – Kannada Text Book",
      "III Language Kannada – Savi Kannada -2",
      "Kannada copy writing – Amulya Kannada copy writing"
    ],
    additionalBooks: [
      "National Geographic Book",
      "Art & Craft – My Art My Way",
      "Health Education Book",
      "English Dictionary",
      "School Atlas"
    ],
    noteBooks: [
      { name: "Single ruled", pages: "200 Pages", qty: "3" },
      { name: "Single ruled", pages: "100 Pages", qty: "9" },
      { name: "Horizontal Maths", pages: "200 Pages", qty: "2" },
      { name: "Horizontal Maths", pages: "100 Pages", qty: "2" },
      { name: "Double ruled", pages: "200 Pages", qty: "2" },
      { name: "Double ruled", pages: "100 Pages", qty: "4" },
      { name: "Four line", pages: "200 Pages", qty: "1" },
      { name: "Four line", pages: "100 Pages", qty: "2" },
      { name: "One side ruled", pages: "200 Pages", qty: "1" },
      { name: "Drawing Book", pages: "40 Pages", qty: "1" },
      { name: "Plain Book", pages: "40 Pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "43" },
      { item: "Books Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "36,000", payBy: "Admission" },
      { term: "II Term", amount: "36,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "5": {
    textBooks: [
      "Eng Literature – Magnolia",
      "Eng Language – Gems English Grammar",
      "Mathematics – Inspired Maths",
      "Science – Inspired Science",
      "Social Studies – Inspired Social",
      "Computer – Pointerz",
      "English Cursive writing",
      "II Language Hindi – Madhukiran Hindi Patmala",
      "III Language Hindi – Elementary Hindi Reader – 4",
      "Hindi Copy Writing – Sulekhmala Hindi Cursive writing",
      "II Language Kannada – Kannada Text Book",
      "III Language Kannada – Savi Kannada 3",
      "Kannada copy writing – Amulya Kannada copy writing"
    ],
    additionalBooks: [
      "National Geographic Book",
      "Art & Craft – My Art My Way",
      "Health Education Book",
      "Pocket Dictionary",
      "School Atlas"
    ],
    noteBooks: [
      { name: "Single ruled", pages: "200 Pages", qty: "5" },
      { name: "Single ruled", pages: "100 Pages", qty: "13" },
      { name: "Horizontal Maths", pages: "200 Pages", qty: "2" },
      { name: "Horizontal Maths", pages: "100 Pages", qty: "2" },
      { name: "Double ruled", pages: "200 Pages", qty: "1" },
      { name: "Double ruled", pages: "100 Pages", qty: "2" },
      { name: "One side ruled", pages: "200 Pages", qty: "2" },
      { name: "Drawing book", pages: "40 Pages", qty: "1" },
      { name: "Plain book", pages: "40 Pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "43" },
      { item: "Books Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "36,000", payBy: "Admission" },
      { term: "II Term", amount: "36,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "6": {
    textBooks: [
      "Eng Literature – Cambridge Connection 6",
      "Eng Language – Gems English Grammar 6",
      "Mathematics – Concise Maths 6",
      "Physics – Concise Physics 6",
      "Chemistry – Concise Chemistry 6",
      "Biology – Concise Biology 6",
      "History/Civics – Past and Present 6",
      "Geography – Around the World 6",
      "Computer – Pointerz 6",
      "Hindi II Language – Ekta Saral Patmala 6",
      "Hindi II Language – Vyakaran Latika 6",
      "Hindi III Language – Sargam Hindi Patmala 4",
      "Kannada II Language – Kannada Text Book",
      "Kannada II Language – Vyakarana Darpana 6",
      "Kannada III Language – Kannada Sangama 4"
    ],
    additionalBooks: [
      "English: Non Detail – Adventures of Huckleberry Finn",
      "Health Education Book",
      "Analytical Thinking",
      "National Geographic Book"
    ],
    noteBooks: [
      { name: "Long ruled", pages: "200 Pages", qty: "12" },
      { name: "Long ruled", pages: "100 Pages", qty: "13" },
      { name: "Unruled long", pages: "100 Pages", qty: "1" },
      { name: "Drawing Book", pages: "40 Pages", qty: "1" },
      { name: "Graph", pages: "", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "43" },
      { item: "Book Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "36,000", payBy: "Admission" },
      { term: "II Term", amount: "36,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "36,000", payBy: "10th December 2026" }
    ]
  },

  "7": {
    textBooks: [
      "Eng Literature – Cambridge Connection 7",
      "Eng Language – Gems English Grammar 7",
      "Mathematics – Concise Maths 7",
      "Physics – Concise Physics 7",
      "Chemistry – Concise Chemistry 7",
      "Biology – Concise Biology 7",
      "History/Civics – Past and Present 7",
      "Geography – Around the World 7",
      "Computer – Pointerz 7",
      "Hindi II Language – Ekta Saral Patmala 7",
      "Hindi II Language – Vyakaran Latika 7",
      "Hindi III Language – Sargam Hindi Patmala 5",
      "Kannada II Language – Kannada Text Book",
      "Kannada II Language – Vyakarana Darpana 7",
      "Kannada III Language – Kannada Sangama 5"
    ],
    additionalBooks: [
      "English: Non Detail – Short stories from Shakespeare",
      "Health Education Book",
      "Analytical Thinking",
      "National Geographic Book"
    ],
    noteBooks: [
      { name: "Long ruled", pages: "200 Pages", qty: "12" },
      { name: "Long ruled", pages: "100 Pages", qty: "13" },
      { name: "Unruled long", pages: "200 Pages", qty: "1" },
      { name: "Drawing Book", pages: "40 Pages", qty: "1" },
      { name: "Graph", pages: "", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "43" },
      { item: "Book Wrapper", qty: "2 Rolls" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "36,000", payBy: "Admission" },
      { term: "II Term", amount: "38,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "38,000", payBy: "10th December 2026" }
    ]
  },

  "8": {
    textBooks: [
      "Eng Literature – Treasure Chest (Collection of Short Stories & Poems)",
      "Drama: Julius Caesar + Workbook",
      "Eng Language – Gems English Grammar 8",
      "Mathematics – Concise Maths 8",
      "Physics – Concise Physics 8",
      "Chemistry – Concise Chemistry 8",
      "Biology – Concise Biology 8",
      "History/Civics – Past & Present 8",
      "Geography – Around the World 8",
      "Computer – Enrich your Computer Studies 8",
      "Hindi II Language – Sahithya Sagar + Abyas Pustak",
      "Hindi II Language – Ekangi Sanchay + Abyas Pustak",
      "Hindi II Language – Saras Vyakaran",
      "Hindi III Language – Sargam Hindi Patmala",
      "Kannada II Language – Sahithya Sangama",
      "Kannada II Language – Sahithya Darpana",
      "Kannada II Language – Natya Mayuri Novel",
      "Kannada III Language – Kannada Sangama – 6"
    ],
    additionalBooks: [
      "Treasure Chest I & II Workbook",
      "Health Education",
      "Analytical Thinking",
      "National Geographic Book"
    ],
    noteBooks: [
      { name: "Long ruled", pages: "200 Pages", qty: "13" },
      { name: "Long ruled", pages: "100 Pages", qty: "13" },
      { name: "Unruled long", pages: "200 Pages", qty: "1" },
      { name: "Graph", pages: "", qty: "2" }
    ],
    stationery: [
      { item: "Labels", qty: "45" },
      { item: "Book Wrapper", qty: "2 Rolls" },
      { item: "Brown Sheets", qty: "2" },
      { item: "Diary", qty: "1" },
      { item: "File / Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "36,000", payBy: "Admission" },
      { term: "II Term", amount: "38,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "38,000", payBy: "10th December 2026" }
    ]
  },

  "9": {
    textBooks: [
      "Eng Lit – Treasure Chest (Collection of Short Stories & Poems)",
      "Drama: Julius Caesar + Workbook",
      "Treasure Chest I & II Workbook",
      "Eng Lang – Total English IX",
      "Mathematics – Concise Maths – 9",
      "Physics – Concise Physics – 9",
      "Chemistry – Concise Chemistry – 9",
      "Biology – Concise Biology – 9",
      "Physics – Lab Manual Record",
      "Chemistry – Lab Manual Record",
      "Biology – Lab Manual Record",
      "His/ Civ – Total His/Civ – 9",
      "Geography – Geography – 9",
      "Computer – Understanding Comp Application with Blue J – IX",
      "Hindi II Lang – Sahithya Sagar + Abyas Pustak",
      "Hindi II Lang – Ekangi Sanchay + Abyas Pustak",
      "Hindi II Lang – Saras Vyakaran",
      "Kannada II Lang – Sahithya Sangama",
      "Kannada II Lang – Sahithya Darpana",
      "Kannada II Lang – Natya Mayuri Novel",
      "Commercial Studies – Commercial Studies - 9",
      "Economics – Economics - 9",
      "Robotics & AI – Robotics & AI – 9",
      "Computer / Robotics – Record Book"
    ],
    additionalBooks: [
      "Health Education",
      "Analytical Thinking",
      "National Geographic Book"
    ],
    noteBooks: [
      { name: "Long Ruled", pages: "200 Pages", qty: "13" },
      { name: "Single ruled", pages: "100 pages", qty: "13" },
      { name: "Unruled long", pages: "200 pgs", qty: "1" },
      { name: "Unruled long", pages: "100 pages", qty: "1" },
      { name: "Graph", pages: "40 Pages", qty: "1" }
    ],
    stationery: [
      { item: "Labels", qty: "51" },
      { item: "Book Wrapper", qty: "2 Rolls" },
      { item: "Brown sheets", qty: "8" },
      { item: "Diary", qty: "1" },
      { item: "File, Folder", qty: "" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "38,000", payBy: "Admission" },
      { term: "II Term", amount: "38,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "38,000", payBy: "10th December 2026" }
    ]
  },

  // Grade 10 - assuming continuation of pattern (you can update when you get actual document)
  "10": {
    textBooks: [
      "English Literature – Treasure Chest / ICSE prescribed text",
      "English Language – Total English / Evergreen",
      "Mathematics – Concise Mathematics X",
      "Physics – Concise Physics X",
      "Chemistry – Concise Chemistry X",
      "Biology – Concise Biology X",
      "History & Civics – Total History & Civics X",
      "Geography – Total Geography X",
      "Computer Applications – Understanding Computer Applications X",
      "Hindi II Lang – Sahitya Sagar / Ekangi Sanchay + Grammar",
      "Kannada II Lang – Sahitya Sangama / Sahitya Darpana",
      "Lab Manuals – Physics, Chemistry, Biology",
      "Record Books – As required"
    ],
    additionalBooks: [
      "ICSE Project Work Books",
      "National Geographic / Reference Books",
      "Analytical Thinking / Logical Reasoning"
    ],
    noteBooks: [
      { name: "Long Ruled / Single Ruled", pages: "200 Pages", qty: "15+" },
      { name: "Long Ruled / Single Ruled", pages: "100 Pages", qty: "10+" },
      { name: "Graph Book", pages: "40–80 Pages", qty: "2–3" },
      { name: "Practical Record Books", pages: "", qty: "3" }
    ],
    stationery: [
      { item: "Labels", qty: "50+" },
      { item: "Book Wrapper", qty: "2–3 Rolls" },
      { item: "Brown Sheets", qty: "10+" },
      { item: "Diary", qty: "1" },
      { item: "Files / Folders", qty: "Multiple" }
    ],
    uniform: [
      "Stitched Regular Uniform – 2 Pairs",
      "School wear – 2 pairs",
      "Belt – 1 No",
      "Tie – 1 No",
      "Socks – 4 pairs"
    ],
    fee: [
      { term: "I Term", amount: "40,000", payBy: "Admission" },
      { term: "II Term", amount: "40,000", payBy: "10th August 2026" },
      { term: "III Term", amount: "42,000", payBy: "10th December 2026" }
    ]
  },

  // Fallback / default
  default: {
    textBooks: ["Please select valid grade"],
    additionalBooks: [],
    noteBooks: [],
    stationery: [],
    uniform: [],
    fee: []
  }
};

export const getGradeData = (grade) => {
  if (!grade) return gradeData.default;

  const normalized = grade.toString().trim();

  const aliases = {
    Montessori: "Montcare",
    "Pre-Nursery": "Montcare",
    Nursery: "Prep I",
    "Prep 1": "Prep I",
    "Prep I": "Prep I",
    LKG: "Prep II",
    "Prep 2": "Prep II",
    "Prep II": "Prep II",
    UKG: "Prep III",
    "Prep 3": "Prep III",
    "Prep III": "Prep III",
    Grade: "", // remove "Grade " prefix if present
    "Grade ": ""
  };

  let key = normalized.replace(/^Grade\s*/i, "").trim();
  key = aliases[key] || key;

  return gradeData[key] || gradeData.default;
};